import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useFindAClass } from "../context/FindAClassContext";
import { useBookingLinks } from "../context/BookingLinksContext";
import { useSiteImages } from "../context/SiteImagesContext";

const GYMTOTS_LOGO = null; // loaded from context

const STATIC_NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Find a Class", href: "#find-a-class", isModal: true },
  { label: "Book a Taster Session", href: "", isExternal: true, isBooking: true },
  { label: "Classes", href: "/classes" },
  { label: "Events", href: "/events" },
  { label: "Gallery", href: "/gallery" },
  { label: "Locations", href: "/locations" },
  { label: "Coaches", href: "/coaches" },
  { label: "Birthday Parties", href: "/birthday-parties" },
  { label: "About Us", href: "/about" },
  { label: "Contact Us", href: "/contact" },
  { label: "Terms", href: "/terms" },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { openFindAClass } = useFindAClass();
  const bookingLinks = useBookingLinks();
  const siteImages = useSiteImages();

  const NAV_ITEMS = STATIC_NAV_ITEMS.map(item => 
    item.isBooking ? { ...item, href: bookingLinks.general || "#" } : item
  );

  const handleNavClick = (item, e) => {
    if (item.isModal) {
      e.preventDefault();
      openFindAClass();
      setMobileMenuOpen(false);
    } else {
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container-gymtots">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a 
            href="/" 
            className="flex items-center flex-shrink-0"
            data-testid="logo-link"
          >
            <img 
              src={siteImages["gymtots-logo.png"] || ""} 
              alt="Gymtots" 
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-4 xl:gap-5">
            {NAV_ITEMS.map((item) => (
              <a 
                key={item.label}
                href={item.href} 
                className={`text-xs xl:text-sm font-medium hover:text-[#ff3131] transition-colors whitespace-nowrap ${item.isExternal ? 'text-[#ff3131] font-bold' : 'text-[#2D3436]'}`}
                onClick={(e) => handleNavClick(item, e)}
                {...(item.isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA Button - Desktop */}
          <button
            onClick={openFindAClass}
            className="hidden lg:flex items-center gap-2 bg-[#ff3131] hover:bg-[#e62e2e] text-white px-4 py-2 rounded-full text-sm font-bold transition-colors flex-shrink-0 cursor-pointer"
            style={{ fontFamily: 'Fredoka, cursive' }}
            data-testid="header-cta"
          >
            Find a Class
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 -mr-2"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[#2D3436]" />
            ) : (
              <Menu className="w-6 h-6 text-[#2D3436]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-100 animate-slide-up">
            <div className="flex flex-col gap-1">
              {NAV_ITEMS.map((item) => (
                <a 
                  key={item.label}
                  href={item.href} 
                  className={`font-medium py-3 px-2 rounded-lg hover:bg-gray-50 ${item.isExternal ? 'text-[#ff3131] font-bold' : 'text-[#2D3436]'}`}
                  onClick={(e) => handleNavClick(item, e)}
                  {...(item.isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                >
                  {item.label}
                </a>
              ))}
              <button
                onClick={() => { openFindAClass(); setMobileMenuOpen(false); }}
                className="bg-[#ff3131] text-white text-center py-3 rounded-full font-bold mt-2 cursor-pointer"
                style={{ fontFamily: 'Fredoka, cursive' }}
                data-testid="mobile-find-class-btn"
              >
                Find a Class
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
